import { useState, useEffect } from "react";

export const useVisionLogin = () => {
  const userVision = localStorage.getItem("userVision");
  const kIdUser = localStorage.getItem("k-user");
  const kIdUserVision = localStorage.getItem("k-user-vision");

  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (userVision) {
      return setUserId(kIdUserVision);
    } else {
      return setUserId(kIdUser);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kIdUserVision, kIdUser, userVision]);

  return {
    userId,
  };
};
